export default "__VITE_ASSET__CvBIyRRP__"